import { Axios } from '@src/app/context/Api/includes/Axios';
import { _translateCriteriaFilters } from '@src/entities/ActionPath/includes/functions';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isNil, omit, pick } from 'lodash';

/**
 * ListCommonCriteriaVersions
 *
 * Retrieves a list of common criteria versions from the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const ListCommonCriteriaVersions = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = omit(payload?.[2], ['page', 'size', 'sort']);
    const thePagination = pick(payload?.[2], ['page', 'size', 'sort']);

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': `/criteria/${thePayload?.id}/version`,
      },
      method: 'GET',
      params: { ...{ apiKey: theApiKey, queryKey: theQueryKey }, ...thePagination },
    };

    const remoteResponse = await Axios.request(requestArgs);

    remoteResponse.data.content = remoteResponse.data.content.map((criteria) => {
      const theCriteria = { ...criteria };

      if (!isNil(theCriteria?.criteria)) {
        theCriteria.criteria = _translateCriteriaFilters(theCriteria?.criteria, 'incoming');
      }

      return theCriteria;
    });

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/Criteria/api/requests/queries/ListCommonCriteriaVersions.js -> ListCommonCriteriaVersions()',
      false,
      error
    );

    throw error;
  }
};
